if(typeof require !== 'undefined'){
    require('flatpickr');
    const {Lithuanian} = require('flatpickr/dist/l10n/lt');
}

class CmsDatepicker {
    static init($context = null){
        var inputSelector = "[data-input='datepicker']:not([data-datepicker]), .datepickermdy";
        let $inputs = $context ? $context.find(inputSelector) : $(inputSelector);
        $inputs.each(function (index, element) {
            if($(element).data('datepicker_instance')) return;
            $(element).data('datepicker_instance', new CmsDatepicker($(element).data('options'), element))
        });
    }
    constructor(config, context) {
        let lang = document.documentElement.getAttribute('lang');
        let $input = $(context);

        if($input.prop('readonly')) return;


        var c = {
            changeMonth: true,
            changeYear: true,
            showButtonPanel: true,
            dateFormat: 'Y-m-d',
            locale: flatpickr.l10ns[lang] ? flatpickr.l10ns[lang] : flatpickr.l10ns.default
        };
        $.extend(c, config);

        let instance = flatpickr(context, c);

        if($input.hasClass('date-range')){
            instance.config.onChange.push(function (selectedDates, dateStr, instance) {
                if($input.hasClass('date-range-from')){
                    let toInstance = $input.parent().find('.date-range-to')[0]._flatpickr;
                    toInstance.config.minDate = dateStr;
                }else if($input.hasClass('date-range-to')){
                    let toInstance = $input.parent().find('.date-range-from')[0]._flatpickr;
                    toInstance.config.maxDate = dateStr;
                }
            }.bind(this))
        }
        if($input.next('button.clear-datetime').length) {
            $input.next('button.clear-datetime').on('click', function(){
                instance.clear();
            });
        }
    }
}


if (typeof module === "object" && typeof module.exports === "object"){
    CmsDatepicker.init()
    //node modules support
    module.exports = CmsDatepicker
}else{
    $(function(){
        CmsDatepicker.init()
    });
}
